import { render, staticRenderFns } from "./EditAndDeleteBtn.vue?vue&type=template&id=7af4b194&scoped=true"
import script from "./EditAndDeleteBtn.vue?vue&type=script&lang=js"
export * from "./EditAndDeleteBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af4b194",
  null
  
)

export default component.exports